import React from 'react'

import { SEO } from 'src/components/SEO'
import { ProductCard } from 'src/components/product/card'

export interface CollectionProps {
  pageContext: {
    main: {
      modules: [],
      slug: {
        current: string
      },
      title: string
    },
    meta: {}
  }
  path: string
}

const Collection = ({
  path,
  pageContext
}: CollectionProps) => {
  const {
    main: {
      modules,
      slug
    },
    products,
    meta
  } = pageContext

  const url = slug.current === 'home' ? '' : path
  return (
    <div className='mt1 al'>
      <SEO metaInfo={meta} pagePath={url} />
      <div className='container--xl outer p1 mxa'>
        <div className='f jcb fw ais'>
          {products && products.map(({ node }: {node: any}) => (
            <ProductCard {...node._rawContent} key={node._rawContent.shopify.productId} />
          ))}
          <div className='c30 grid__product' />
          <div className='c30 grid__product' />
        </div>
      </div>
    </div>
  )
}

export default Collection